<template>
  <span
    v-if="icon"
    class="app-icon"
    :class="[
      { 'app-icon--with-background': backgroundColor },
      `app-icon--${size}`,
    ]"
    :style="{ 'background-color': icon && backgroundColor }"
    role="presentation"
    v-html="icon"
  />
  <span
    v-else
    class="app-icon app-icon--default"
    :class="[
      { 'app-icon--with-background': backgroundColor },
      `app-icon--${size}`,
    ]"
    :style="{ 'background-color': icon && backgroundColor }"
    role="presentation"
  />
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        required: true,
      },
      backgroundColor: {
        type: String,
        default: '',
      },
      size: {
        type: String,
        validator: value => ['small', 'medium', 'large'].indexOf(value) !== -1,
        default: 'small',
      },
    },
    computed: {
      icon() {
        try {
          return require(`../../static/icons/${this.name}.svg`)
        } catch {
          console.warn(
            `AppIcon not found: '${this.name}'. Check static assets for available icons.`,
          )
          return false
        }
      },
    },
  }
</script>

<style lang="scss" src="./AppIcon.scss"></style>
